import openModal from 'App/services/Modal/Modal';
import ContactResource from 'Resources/Contact';
import RequestBuilder from 'Resources/RequestBuilder';
import ComparisonTypes from 'Resources/ComparisonTypes';
import ContactAttributes from 'App/babel/attributes/Contact';
import NotificationService from 'App/babel/NotificationService';
import logError from 'Helpers/logError';
import { SEGMENT_MAX_CONTACTS } from 'App/helpers/segmentAccess';

// A second click while a company's lookup is out would stack a second modal and post the add twice.
const loading = new Set<number>();

/** Opens the add-to-segment modal on the company's active contacts, as they are right now. */
export default async function addClientContactsToSegment(clientId: number) {
	if (loading.has(clientId)) {
		return;
	}
	loading.add(clientId);
	const filter = new RequestBuilder();
	filter.addFilter(ContactAttributes.account, ComparisonTypes.Equals, clientId);
	filter.addFilter(ContactAttributes.active, ComparisonTypes.Equals, true);
	filter.fields = ['id'];
	filter.limit = SEGMENT_MAX_CONTACTS;

	try {
		const { data, metadata } = await ContactResource.find(filter.build());

		if (!data.length) {
			NotificationService.add({
				style: NotificationService.style.WARN,
				icon: 'warning',
				title: 'default.addToSegment',
				body: 'default.noActiveContacts'
			});
			return;
		}
		if (metadata.total > SEGMENT_MAX_CONTACTS) {
			NotificationService.add({
				style: NotificationService.style.WARN,
				icon: 'warning',
				title: 'default.addToSegment',
				body: 'multi.addContactsToSegment.maxContacts'
			});
			return;
		}

		openModal('AddToSegmentModal', { selected: data.map(({ id }: { id: number }) => id) });
	} catch (error) {
		logError(error, 'addClientContactsToSegment - could not load the company contacts');
		NotificationService.add({
			style: NotificationService.style.ERROR,
			icon: 'times',
			title: 'default.error',
			body: 'default.somethingWrong'
		});
	} finally {
		loading.delete(clientId);
	}
}
